import React from 'react';

import { ROUTES } from '@constants/routes';
import WithConfiguration from '@domain/layout/with-configuration';
import ExternalElearningFinalPage from '@pages/elearning-external/final-page';
import ExternalElearningLogoutSuccessfulPage from '@pages/elearning-external/logout-successful-page';
import ExternalElearningOtpPage from '@pages/elearning-external/otp-page';
import ExternalElearningRegisterPage from '@pages/elearning-external/register-page';
import ExternalElearningLayout from '@pages/elearning-external/shared/eel-layout';
import ExternalElearningVideoPage from '@pages/elearning-external/video-page';
import ExternalElearningWelcomePage from '@pages/elearning-external/welcome-page';
import ElearningWpOnSiteDobPage from '@pages/elearning-wp-onsite/dob-page';
import ElearningWpOnSiteFinalPage from '@pages/elearning-wp-onsite/final-page';
import ElearningWpOnSiteLoginPage from '@pages/elearning-wp-onsite/login-page';
import ElearningWpOnSiteMvePage from '@pages/elearning-wp-onsite/mve-page';
import ElearningWpOnSiteRegisterPage from '@pages/elearning-wp-onsite/register-page';
import ElearningWpOnSiteLayout from '@pages/elearning-wp-onsite/shared/ewos-layout';
import ElearningWpOnSiteVideoPage from '@pages/elearning-wp-onsite/video-page';
import ElearningWpOnSiteWelcomePage from '@pages/elearning-wp-onsite/welcome-page';
import ElearningWpRemoteFinalPage from '@pages/elearning-wp-remote/final-page';
import ElearningWpRemoteLogoutSuccessfulPage from '@pages/elearning-wp-remote/logout-successful-page';
import ElearningWpRemoteOtpPage from '@pages/elearning-wp-remote/otp-page';
import ElearningWpRemoteRegisterPage from '@pages/elearning-wp-remote/register-page';
import ElearningWpRemoteLayout from '@pages/elearning-wp-remote/shared/ewr-layout';
import ElearningWpRemoteVideoPage from '@pages/elearning-wp-remote/video-page';
import ElearningWpRemoteWelcomePage from '@pages/elearning-wp-remote/welcome-page';
import VisitorFinalPage from '@pages/visitor-registration/final-page';
import Login from '@pages/visitor-registration/login';
import VisitorRegisterPage from '@pages/visitor-registration/register-page';
import VisitorVideoPage from '@pages/visitor-registration/video-page';
import VisitorWelcomePage from '@pages/visitor-registration/welcome-page';
import VismaOnsite from '@pages/visma-on-site';

export interface RouteConfig {
  path: string;
  component: React.ComponentType;
  wrapper: React.ComponentType<{ children: React.ReactNode }> | null;
}

export const authenticatedRoutes: RouteConfig[] = [
  { path: ROUTES.VISMA_ONSITE, component: VismaOnsite, wrapper: null },

  {
    path: ROUTES.VR_WELCOME,
    component: VisitorWelcomePage,
    wrapper: WithConfiguration
  },
  {
    path: ROUTES.VR_REGISTER,
    component: VisitorRegisterPage,
    wrapper: WithConfiguration
  },
  {
    path: ROUTES.VR_VIDEO,
    component: VisitorVideoPage,
    wrapper: WithConfiguration
  },
  {
    path: ROUTES.VR_FINAL,
    component: VisitorFinalPage,
    wrapper: WithConfiguration
  },

  {
    path: ROUTES.EWR_OTP,
    component: ElearningWpRemoteOtpPage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EWR_WELCOME,
    component: ElearningWpRemoteWelcomePage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EWR_REGISTER,
    component: ElearningWpRemoteRegisterPage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EWR_VIDEO,
    component: ElearningWpRemoteVideoPage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EWR_FINAL,
    component: ElearningWpRemoteFinalPage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EWR_LOGOUT,
    component: ElearningWpRemoteLogoutSuccessfulPage,
    wrapper: ElearningWpRemoteLayout
  },

  {
    path: ROUTES.EEL_OTP,
    component: ExternalElearningOtpPage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EEL_WELCOME,
    component: ExternalElearningWelcomePage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EEL_REGISTER,
    component: ExternalElearningRegisterPage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EEL_VIDEO,
    component: ExternalElearningVideoPage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EEL_FINAL,
    component: ExternalElearningFinalPage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EEL_LOGOUT,
    component: ExternalElearningLogoutSuccessfulPage,
    wrapper: ExternalElearningLayout
  },

  {
    path: ROUTES.EWOS_MVE,
    component: ElearningWpOnSiteMvePage,
    wrapper: ElearningWpOnSiteLayout
  },
  {
    path: ROUTES.EWOS_DOB,
    component: ElearningWpOnSiteDobPage,
    wrapper: ElearningWpOnSiteLayout
  },
  {
    path: ROUTES.EWOS_WELCOME,
    component: ElearningWpOnSiteWelcomePage,
    wrapper: ElearningWpOnSiteLayout
  },
  {
    path: ROUTES.EWOS_REGISTER,
    component: ElearningWpOnSiteRegisterPage,
    wrapper: ElearningWpOnSiteLayout
  },
  {
    path: ROUTES.EWOS_VIDEO,
    component: ElearningWpOnSiteVideoPage,
    wrapper: ElearningWpOnSiteLayout
  },
  {
    path: ROUTES.EWOS_FINAL,
    component: ElearningWpOnSiteFinalPage,
    wrapper: ElearningWpOnSiteLayout
  }
];

export const unauthenticatedRoutes: RouteConfig[] = [
  { path: ROUTES.VISMA_ONSITE, component: VismaOnsite, wrapper: null },
  { path: ROUTES.VR_LOGIN, component: Login, wrapper: WithConfiguration },
  {
    path: ROUTES.EWR_OTP,
    component: ElearningWpRemoteOtpPage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EWR_LOGOUT,
    component: ElearningWpRemoteLogoutSuccessfulPage,
    wrapper: ElearningWpRemoteLayout
  },
  {
    path: ROUTES.EEL_OTP,
    component: ExternalElearningOtpPage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EEL_LOGOUT,
    component: ExternalElearningLogoutSuccessfulPage,
    wrapper: ExternalElearningLayout
  },
  {
    path: ROUTES.EWOS_LOGIN,
    component: ElearningWpOnSiteLoginPage,
    wrapper: ElearningWpOnSiteLayout
  }
];
